import { Component } from "@angular/core";
import { KartleggCard } from "src/app/pages/start/components/kartlegg-card/kartlegg-card";
import { SlikFungererBoligkompasset } from "./components/slik-fungerer-boligkompasset/slik-fungerer-boligkompasset";

@Component({
  selector: "bko-start",
  imports: [KartleggCard, SlikFungererBoligkompasset],
  templateUrl: "./start.html",
  styleUrl: "./start.scss",
})
export class Start {}
